import { AxiosError } from 'axios';
import { api } from '.';

const responseInter = () => {
    api.interceptors.response.use(
        response => response,
        (error: AxiosError) => {
            const response = error.response;

            const errorResponse = {
                error: true,
                status: response?.status,
                redirect: '',
                statusText: response?.statusText,
            };

            if (response?.status === 403 || response?.status === 401) {
                localStorage.clear();
                sessionStorage.clear();
            }

            if (response?.statusText === 'MFA_Required') {
                errorResponse.redirect = '/error/401MFA';
            } else if (response?.status === 400) {
                console.error('', response.data);
                errorResponse.redirect = `/error/${response?.status}`;
            }

            return new Promise((_, reject) => {
                reject(errorResponse);
            });
        }
    );
};

export default responseInter;
